import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { updateSearchFilters as update, clearSearchFilters as clear } from '../../../../actions';
import Icon from './Icon';

const ProjectTypeSelector = ({ projectType: { name, label, id } }) => {
  const {
    parameters: {
      parent_project_type_ids_contains_element: parentProjectTypeId,
    },
  } = useSelector((state) => state.searchFilters);
  const dispatch = useDispatch();

  const filterIsActive = id === parentProjectTypeId;

  const toggleSelector = () => (
    filterIsActive
      ? dispatch(clear(['parent_project_type_ids_contains_element']))
      : dispatch(update({ parent_project_type_ids_contains_element: id }))
  );

  const buttonClassName = `button-selector-item ${filterIsActive ? 'active' : null}`;

  return (
    <button type="button" onClick={toggleSelector} className={buttonClassName} key={name}>
      <Icon iconName={label} />
      <div className="project-type-name-wrapper">
        <span className="project-type-name">{name}</span>
      </div>
    </button>
  );
};

ProjectTypeSelector.propTypes = {
  projectType: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
};

export default ProjectTypeSelector;
